import { Button, Container, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import format from 'utils/formatMoney'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useWallets } from 'modules/Finance/Wallets/useWallets'
import PromisedPaymentsSwitcher from './PromisedPaymentsSwitcher'
import WalletHeadSkeleton from 'modules/Finance/Wallets/subcomponents/WalletHead/Skeleton'
import styles from 'modules/Finance/Wallets/subcomponents/WalletHead/wallet-head.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'

const WalletHead = ({ listMode }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()
  const { activeWalletID, activeWallet } = useWallets()
  const { i18n } = useSelector(({ app }) => app)

  const {
    id,
    currency,
    balance,
    financial_profile: { financial_profile_type: { type = null } = {}, custom_name } = {},
  } = activeWallet

  if (!activeWalletID) {
    return <WalletHeadSkeleton />
  }

  return (
    <div className={'margin-bottom-24'}>
      <Typography variant={'Header-60'} className={'margin-bottom-24'}>
        {t('wallets::nav.wallets_header')}
      </Typography>
      <Typography
        weight={'light'}
        className={styles['wallet-head__balance']}
        noMargin
        variant={'h4'}
        dangerouslySetInnerHTML={{
          __html: format(balance, currency),
        }}
      />
      <Container display={'flex'} flexAlign={'center'} className={styles['wallet-head__type-info']}>
        <Typography variant={'p9'} noMargin>
          {custom_name ?? t(`wallets::types.${type}`)}
        </Typography>
      </Container>
      {!['partner', 'ad-tax-hold'].includes(type) && (
        <Container display={'flex'} className={styles['wallet-head__buttons-container']}>
          <Link to={pathGen(ROUTES.BILLING_TOP_UP)} className={styles['wallet-head__button']}>
            <Button
              size={breakpoints.fb ? 'm' : 'l'}
              variant="primary"
              startIcon={<Icon name="card" />}
              noLabel={breakpoints.sm}
            >
              {t('wallets::transaction.fillUp')}
            </Button>
            {breakpoints.sm && (
              <Typography variant={'p10'} noMargin color={'text-primary'}>
                {t('wallets::transaction.fillUp')}
              </Typography>
            )}
          </Link>
          <PromisedPaymentsSwitcher i18n={i18n} id={id} listMode={listMode} />
        </Container>
      )}
    </div>
  )
}

WalletHead.propTypes = {
  listMode: PropTypes.oneOf(['transactions', 'promised-payments']),
}

export default WalletHead
